Auth = require 'app/scripts/db/auth'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
{ getKey, Key } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
template = require 'app/scripts/views/templates/template_banner'
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ ShareTemplatePopover } = require 'app/src/components/ShareTemplatePopover'
{ siteDomain } = require '@trello/config'
{ Analytics } = require '@trello/atlassian-analytics'
l = require 'app/scripts/lib/localize'

module.exports = class TemplateBannerView extends WarningBannerView
  className: "header-banner mod-warning template-banner"

  initialize: ->
    super

    @makeDebouncedMethods 'render'
    @listenTo @model,
      'change:closed': @renderDebounced
      'change:prefs.isTemplate': @renderDebounced
      'change:prefs.permissionLevel': @renderDebounced
      'change:idOrganization': @renderDebounced

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', false, (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

  events:
    'click .js-share-template': 'shareTemplate'
    'click .js-copy-template': 'copyTemplate'

  copyTemplate: (e) ->
    Util.stop(e)
    trackUe('template banner', 'opens', 'create board from template menu', '', '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'createBoardFromTemplateButton'
      source: 'boardScreen'
      containers:
        board:
          id: @model.id
        organization:
          id: @model.get('idOrganization') || ''

    PopOver.toggle
      elem: @$(e.target).closest('.js-copy-template')
      view: new CopyBoardView({
        @templateFlagEnabled,
        @model,
        @modelCache,
        boardNameInputValue: @model.get('name')
      })

  shareTemplate: (e) ->
    Util.stop(e)
    trackUe('template banner', 'opens', 'share template menu', '', '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'link'
      actionSubjectId: 'shareTemplateLink'
      source: 'boardScreen'
      container:
        board:
          id: @model.id
        organization:
          id: @model.get('idOrganization') || ''

    @reactRoot = @$('.js-share-template')[0]

    templateCategory = @model.get('templateGallery')?.category
    if templateCategory
      storyPageUrl = "#{siteDomain}/templates/#{templateCategory}/#{Util.makeSlug(@model.get('name'))}-#{@model.get('shortLink')}"

    props =
      key: 'ShareTemplatePopover'
      orgName: @model.getOrganization()?.get('displayName')
      enterpriseName: @model.getOrganization()?.getEnterprise()?.get('displayName')
      url: @model.get('url')
      storyPageUrl: storyPageUrl
      visibility: @model.getPermLevel()
      boardId: @model.id,
      teamId: @model.getOrganization()?.id,
      isTemplate: @model.isTemplate() && @templateFlagEnabled
      username: Auth.me().get('username')
    PopOver.toggle
      reactElement: React.createElement ShareTemplatePopover, props
      elem: @reactRoot
      getViewTitle: -> l ['view title', 'share template']

  getTeamName: ->
    switch @model.getPermLevel()
      when 'enterprise' then @model.getEnterprise()?.get('displayName')
      when 'org' then @model.getOrganization()?.get('displayName')

  render: ->
    isTemplate = @model.isTemplate() && @templateFlagEnabled
    isVisible = isTemplate && !@model?.get('closed')
    returnUrl = encodeURIComponent(window.location.pathname)

    @$el.toggleClass('hide', !isVisible)
    @$el.html template({
      isVisible,
      isPrivate: @model.getPermLevel() == 'private',
      isPublic: @model.getPermLevel() == 'public',
      isLoggedIn: Auth.isLoggedIn(),
      teamName: @getTeamName(),
      returnUrl: "/signup?returnUrl=#{returnUrl}"
    })
    @
